import { render, staticRenderFns } from "./SurveyNotification.vue?vue&type=template&id=baffc31a&scoped=true"
import script from "./SurveyNotification.vue?vue&type=script&lang=js"
export * from "./SurveyNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baffc31a",
  null
  
)

export default component.exports